import type { ReactNode } from 'react';
import { View, type ViewProps } from 'react-native';

type PostHogNoCaptureViewProps = ViewProps & {
  children: ReactNode;
};

export function PostHogNoCaptureView({
  children,
  ...props
}: PostHogNoCaptureViewProps) {
  return (
    <View {...(props as any)} ph-no-capture>
      {children}
    </View>
  );
}
